import { AspectViewType } from '@lib.core/entities/indicator/indicator-view-type';
import { AspectViewConfigModel } from '@lib.core/entities/indicator/indicator-view';

export interface AspectViewConfigModelDTO {
  visualizations: VisualizationDTO[];
  aspectViewNameid: string;
  aspectViewType: AspectViewType;
  config: any;
}

interface VisualizationDTO {
  nameid: string;
  type: AspectViewTypeDTO;
}

export enum AspectViewTypeDTO {
  CARD = 'card',
  MAP = 'map',
  CHART = 'chart',
  RANKING = 'ranking',
  KPI = 'kpi',
}

export const DTO_TO_VIEW_TYPE_MAP = {
  [AspectViewTypeDTO.CARD]: AspectViewType.CARD,
  [AspectViewTypeDTO.MAP]: AspectViewType.MAP,
  [AspectViewTypeDTO.CHART]: AspectViewType.CHART,
  [AspectViewTypeDTO.RANKING]: AspectViewType.RANKING,
  [AspectViewTypeDTO.KPI]: AspectViewType.KPI,
};
export const VIEW_TYPE_TO_DTO_MAP = {
  [AspectViewType.CARD]: AspectViewTypeDTO.CARD,
  [AspectViewType.MAP]: AspectViewTypeDTO.MAP,
  [AspectViewType.CHART]: AspectViewTypeDTO.CHART,
  [AspectViewType.RANKING]: AspectViewTypeDTO.RANKING,
  [AspectViewType.KPI]: AspectViewTypeDTO.KPI,
};

export class AspectViewTypeConverter {
  static aspectViewTypeFromDTO(dto: AspectViewTypeDTO): AspectViewType {
    const viewType = DTO_TO_VIEW_TYPE_MAP[dto];
    if (!viewType) {
      throw new Error(`Unknown AspectViewTypeDTO: ${dto}`);
    }
    return viewType;
  }

  static aspectViewTypeToDTO(viewType: AspectViewType): AspectViewTypeDTO {
    const dto = VIEW_TYPE_TO_DTO_MAP[viewType];
    if (!dto) {
      throw new Error(`Unknown AspectViewType: ${viewType}`);
    }
    return dto;
  }
}

export function newAspectViewConfigModelFromDTO(viewInstance: AspectViewConfigModelDTO): [AspectViewConfigModel, Error | null] {
  const { visualizations, aspectViewNameid, aspectViewType, config } = viewInstance;
  if (visualizations.length === 0) {
    return [new AspectViewConfigModel(aspectViewNameid, aspectViewType, [], config), new Error('visualizations is empty')];
  }
  return [
    new AspectViewConfigModel(
      aspectViewNameid,
      aspectViewType,
      visualizations.map(viz => ({ nameId: viz.nameid, type: AspectViewTypeConverter.aspectViewTypeFromDTO(viz.type) })),
      config
    ),
    null
  ];
}
